import { EditorState, Modifier, RichUtils } from 'draft-js';
import Immutable from 'immutable';
import CodeUtils from 'draft-js-code';
import PrismDecorator from 'draft-js-prism';
import { Prism } from 'vendors';
import { CodeBlock } from './CodeBlock';
import { SyntaxSelector } from './SyntaxSelector';
import { createToolbarButtons } from 'lib/editor/DraftEditor/plugins/createToolbarButtons';

const defaultOptions = {
	defaultSyntax: 'js',
	supportSyntaxSelect: true,
	buttons: ['syntax'],
};

const BUTTON_MAP = {
	syntax: SyntaxSelector,
};

/**
 * @returns {DraftEditorPlugin}
 */
export function createCodeEditPlugin(options = defaultOptions) {
	const { supportSyntaxSelect, defaultSyntax, buttons } = { ...defaultOptions, ...options };
	return {
		name: 'code-edit',

		getToolbarButtons(props) {
			if (props.env !== 'root') {
				return null;
			}
			const editorState = props.store.getEditorState();
			// 代码块不支持图片
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return createToolbarButtons(BUTTON_MAP, buttons, props);
			}
			return null;
		},

		handleCommand({ getEditorState, setEditorState }, command, evt) {
			const editorState = getEditorState();
			if (CodeUtils.hasSelectionInBlock(editorState)) {
				switch (command) {
					case 'return':
						return setEditorState(CodeUtils.handleReturn(evt, editorState)), 'handled';
					case 'tab':
						// 这个 onTab 实现的比较粗暴，还不支持 Shift，有空自己实现一个
						return setEditorState(CodeUtils.onTab(evt, editorState)), 'handled';
					default:
						const newEditorState = CodeUtils.handleKeyCommand(editorState, command);
						return newEditorState ? (setEditorState(newEditorState), 'handled') : 'not-handled';
				}
			}
			return 'not-handled';
		},

		handlePastedText(store, text) {
			const editorState = store.getEditorState();
			const content = editorState.getCurrentContent();
			const selection = editorState.getSelection();

			const selectedBlockStart = content.getBlockForKey(selection.getStartKey());
			const selectedBlockEnd = content.getBlockForKey(selection.getEndKey());
			if (selectedBlockStart !== selectedBlockEnd || selectedBlockStart.getType() !== 'code-block') {
				return 'not-handled';
			}

			store.setEditorState(
				EditorState.push(
					editorState,
					Modifier.insertText(content, selection, text),
					'insert-characters'
				)
			);
			return 'handled';
		},

		getDecorators() {
			const prismDecorator = new PrismDecorator({
				prism: Prism,
				defaultSyntax,
				getSyntax: block => {
					if (block.getData) {
						let syntax = block.getData().get('syntax') || defaultSyntax;
						syntax = syntax.toLowerCase();
						if (!Prism.languages[syntax]) {
							syntax = defaultSyntax;
						}
						return syntax;
					}
				},
				render: ({ type, children }) => (
					<span className={`prism-token token ${type || ''}`}>{children}</span>
				),
			});
			return [prismDecorator];
		},

		getBlockRenderInfo(block, store) {
			if (block.getType() === 'code-block') {
				return {
					component: CodeBlock,
					editable: true,
				};
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/codeEditPlugin/createCodeEditPlugin.js